// extracted by mini-css-extract-plugin
export default {"root":"hxI09V","actions":"lm4nK3","mobile":"XXtziM","image":"I8XPny"};